document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".js-product-subscription").forEach(function (selector) {
    /* ---------- Elements ---------- */

    const options = selector.querySelectorAll(".js-product-subscription-option");
    if (!options.length) return;

    const planSelect = selector.querySelector(".js-product-subscription-plan");
    const priceNow = selector.querySelector(".js-product-subscription-price-now");
    const priceWas = selector.querySelector(".js-product-subscription-price-was");
    const oneTimePrice = Number(selector.dataset.oneTimePrice);

    // Main form
    const form = selector.closest("form");
    const sellingPlanSelect = form?.querySelector(".js-selling-plan-select");
    const productAddToCart = form?.querySelector(".js-product-add-to-cart");
    const addToCartPrice = productAddToCart?.querySelector(".js-product-add-to-cart [data-add-to-cart-price]",);

    // Sticky add to cart
    const stickyAddToCart = document.querySelector(".js-sticky-add-to-cart");
    const stickyForm = stickyAddToCart?.closest("form");
    const stickySellingPlan = stickyForm?.querySelector(".js-sticky-selling-plan");
    const stickyAddToCartPrice = stickyAddToCart?.querySelector(".js-sticky-add-to-cart [data-add-to-cart-text-price]",);
    const stickyPricing = document.querySelector(".js-sticky-add-to-cart-pricing");
    const stickyCaption = document.querySelector(".js-sticky-add-to-cart-subscription-caption");

    // Mobile custom selector
    const mobileSelector = selector.querySelector(".js-product-subscription-mobile-select");
    const mobileTrigger = selector.querySelector(".js-product-subscription-mobile-trigger");
    const mobileValue = selector.querySelector(".js-product-subscription-mobile-value");
    const mobileDropdown = selector.querySelector(".js-product-subscription-mobile-dropdown");

    /* ---------- Main price ---------- */

    function updateMainPrice(price, formattedPrice) {
      if (!formattedPrice) return;

      if (priceNow) priceNow.textContent = formattedPrice;
      if (addToCartPrice) addToCartPrice.textContent = formattedPrice;
      if (stickyAddToCartPrice) stickyAddToCartPrice.textContent = formattedPrice;
      if (stickyPricing) stickyPricing.textContent = formattedPrice;

      if (priceWas) {
        priceWas.hidden = price >= oneTimePrice;

        if (!priceWas.hidden) {
          priceWas.textContent = selector.dataset.oneTimePriceFormatted;
        }
      }
    }

    /* ---------- Selling plan ---------- */

    function syncStickySellingPlan(value) {
      if (stickySellingPlan) stickySellingPlan.value = value || "";
    }

    function findSellingPlanOption(planValue) {
      const planOptions = Array.from(sellingPlanSelect.options);

      if (planValue === "one-time") {
        return planOptions.find(function (option) {
          return (
            option.value === "" ||
            option.dataset.sellingPlan === "one-time" ||
            option.textContent.toLowerCase().includes("one-time")
          );
        });
      }

      return planOptions.find(function (option) {
        return option.value === planValue;
      });
    }

    function syncSellingPlan(planValue) {
      if (sellingPlanSelect) {
        const targetOption = findSellingPlanOption(planValue);

        if (targetOption) {
          sellingPlanSelect.value = targetOption.value;
          targetOption.selected = true;
          sellingPlanSelect.dispatchEvent(new Event("change", { bubbles: true }));
        }
      }

      syncStickySellingPlan(planValue === "one-time" ? "" : planValue);
    }

    /* ---------- Sticky subscription caption ---------- */

    function updateStickyCaption(plan) {
      if (!stickyCaption || !plan) return;

      const discount = Number(plan.dataset.planDiscount || 0);
      const frequency = plan.textContent.trim();

      if (!discount || !frequency) return;

      stickyCaption.textContent = `Subscribe and save ${discount}% · every ${frequency}`;
      stickyCaption.classList.remove("hidden");
    }

    function hideStickyCaption() {
      if (!stickyCaption) return;

      stickyCaption.classList.add("hidden");
      stickyCaption.textContent = "";
    }

    /* ---------- Mobile selector ---------- */

    function createMobileOptions() {
      if (!mobileDropdown || !planSelect) return;

      mobileDropdown.innerHTML = "";

      Array.from(planSelect.options).forEach(function (option) {
        const mobileOption = document.createElement("button");

        mobileOption.type = "button";
        mobileOption.className = "js-product-subscription-mobile-option";
        mobileOption.setAttribute("role", "option");
        mobileOption.setAttribute("aria-selected", "false");
        mobileOption.dataset.value = option.value;

        // IMPORTANT: only the option label, no price.
        mobileOption.textContent = option.textContent.trim();

        mobileDropdown.appendChild(mobileOption);
      });
    }

    function updateMobileSelector() {
      if (!mobileSelector || !mobileValue || !planSelect) return;

      const selectedOption = planSelect.options[planSelect.selectedIndex];

      if (!selectedOption) {
        mobileValue.textContent = "";
        return;
      }

      // Same text as the native desktop option.
      mobileValue.textContent = selectedOption.textContent.trim();

      if (!mobileDropdown) return;

      mobileDropdown.querySelectorAll(".js-product-subscription-mobile-option").forEach(function (mobileOption) {
        const isSelected = mobileOption.dataset.value === selectedOption.value;

        mobileOption.classList.toggle("is-selected", isSelected);
        mobileOption.setAttribute("aria-selected", String(isSelected));
      });
    }

    function openMobileSelector() {
      if (!mobileSelector || !mobileDropdown || !mobileTrigger) return;
      if (mobileSelector.classList.contains("is-disabled")) return;

      mobileDropdown.hidden = false;
      mobileTrigger.setAttribute("aria-expanded", "true");
      mobileSelector.classList.add("is-open");
    }

    function closeMobileSelector() {
      if (!mobileSelector || !mobileDropdown || !mobileTrigger) return;

      mobileDropdown.hidden = true;
      mobileTrigger.setAttribute("aria-expanded", "false");
      mobileSelector.classList.remove("is-open");
    }

    function toggleMobileSelector() {
      if (!mobileDropdown) return;

      if (mobileDropdown.hidden) {
        openMobileSelector();
      } else {
        closeMobileSelector();
      }
    }

    /* ---------- Mobile selector events ---------- */

    if (mobileTrigger) {
      mobileTrigger.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        toggleMobileSelector();
      });
    }

    if (mobileDropdown) {
      mobileDropdown.addEventListener("click", function (event) {
        const mobileOption = event.target.closest(".js-product-subscription-mobile-option");
        if (!mobileOption) return;

        const value = mobileOption.dataset.value;
        if (!value || !planSelect) return;

        // Update the REAL select and let the existing logic
        // handle prices, selling plan, sticky ATC, etc.
        planSelect.value = value;
        planSelect.dispatchEvent(new Event("change", { bubbles: true }));

        updateMobileSelector();
        closeMobileSelector();
      });
    }

    document.addEventListener("click", function (event) {
      if (mobileSelector && !mobileSelector.contains(event.target)) {
        closeMobileSelector();
      }
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape") closeMobileSelector();
    });

    /* ---------- Subscription price ---------- */

    function updateSubscriptionPrice() {
      if (!planSelect) return;

      const selectedPlan = planSelect.selectedOptions[0];
      if (!selectedPlan) return;

      const price = Number(selectedPlan.dataset.planPrice);
      const formattedPrice = selectedPlan.dataset.planPriceFormatted;

      updateMainPrice(price, formattedPrice);
      syncSellingPlan(selectedPlan.value);
      updateStickyCaption(selectedPlan);
      updateMobileSelector();
    }

    /* ---------- Purchase option ---------- */

    function updatePurchaseOption(value) {
      const isSubscription = value === "subscription";

      options.forEach(function (option) {
        const isSelected = option.dataset.subscriptionOption === value;
        const radio = option.querySelector(".js-product-subscription-radio");

        option.classList.toggle("is-selected", isSelected);
        option.dataset.subscriptionSelected = isSelected;

        if (radio) radio.classList.toggle("is-selected", isSelected);
      });

      // Native desktop select
      if (planSelect) planSelect.disabled = !isSubscription;

      // Custom mobile selector
      if (mobileSelector) mobileSelector.classList.toggle("is-disabled", !isSubscription);

      if (isSubscription) {
        updateSubscriptionPrice();
        return;
      }

      updateMainPrice(oneTimePrice, selector.dataset.oneTimePriceFormatted);
      syncSellingPlan("one-time");
      hideStickyCaption();
      updateMobileSelector();
      closeMobileSelector();
    }

    /* ---------- Purchase option events ---------- */

    function isInsidePlanSelect(event) {
      return event.target.closest && event.target.closest(".js-product-subscription-plan");
    }

    options.forEach(function (option) {
      option.addEventListener("click", function (event) {
        if (isInsidePlanSelect(event)) return;

        updatePurchaseOption(option.dataset.subscriptionOption);
      });

      option.addEventListener("keydown", function (event) {
        if (event.key !== "Enter" && event.key !== " ") return;
        if (isInsidePlanSelect(event)) return;

        event.preventDefault();
        updatePurchaseOption(option.dataset.subscriptionOption);
      });
    });

    if (planSelect) {
      planSelect.addEventListener("change", updateSubscriptionPrice);
    }

    /* ---------- Init ---------- */

    createMobileOptions();

    const initialOption = selector.querySelector(".js-product-subscription-option.is-selected") || selector.querySelector('[data-subscription-option="subscription"]');

    if (initialOption) {
      updatePurchaseOption(initialOption.dataset.subscriptionOption);
    }

    /* ---------- Sticky ATC ---------- */

    if (stickyAddToCart && productAddToCart) {
      stickyAddToCart?.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        productAddToCart.click();
      },true,);
    }
  });
});